import React from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import logo from "../../../../src/assets/substratum-protocol/logo-substratum-protocol.webp";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import { useEffect } from "react";
import "./substratum-protocol-styles.scss";

import firefight from "../../../../src/assets/substratum-protocol/session03/firefight.webp";
import sector04 from "../../../../src/assets/substratum-protocol/session03/sector-04-travel.webp";
import clue31 from "../../../../src/assets/substratum-protocol/session03/anomoly-clue-31-oscillating-shadows.webp";
import mosheBlackEyes from "../../../../src/assets/substratum-protocol/session03/moshe-black-eyes.webp";
import clue44 from "../../../../src/assets/substratum-protocol/session03/anomoly-clue-44-crystalline-spire.webp";
import cruciformBleeder from "../../../../src/assets/substratum-protocol/session03/cruciform-bleeder-portrait.webp";
import sector05 from "../../../../src/assets/substratum-protocol/session03/sector-05-mood-caustic-pools-table.webp";
import sector06 from "../../../../src/assets/substratum-protocol/session03/sector-06-mood-gravity-inversion-zone.webp";
import sector07 from "../../../../src/assets/substratum-protocol/session03/sector-07-mood-alpha-particle-grove.webp";
import energyBeings from "../../../../src/assets/substratum-protocol/session03/sector-07-encounter-energy-beings.webp";
import visitorsOutOfTime from "../../../../src/assets/substratum-protocol/session03/sector-07-encounter-visitors-out-of-time.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "1",
  marginTop: "20px",
  padding: "15px",
};

const cardStyle = {
  textAlign: "left",
  fontFamily: "Carter One",
  backgroundColor: "rgba(0, 0, 0, 1)",
  color: "white",
  marginBottom: "15px",
};

const SPSession03 = () => {
  const section1Data = [
    {
      title: "",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            <h3 style={{ color: "#c47768" }}>
              WARNING: session notes for Substratum Protocol contain spoilers.
              While the envisioning of the sectors, hazards, discoveries, and
              understandings are unique to our group, please do not read if you
              want to encounter the game without any prior knowledge.
            </h3>
          </p>
          <p>
            <img
              src={sector04}
              alt="Super Heated Lake"
              className="imageWrapper"
            />
          </p>
          <p>
            The scientists begin this session in{" "}
            <strong>Sector 04: Super-Heated Lake</strong>, continuing their
            descent into the strange subterranean world of the Fracture.
          </p>

          <p>
            With the protection of their exosuits, Burns and Moshe enter an
            underwater tunnel filled with wonders. Alien seahorses drift through
            the water, their bodies equipped with strange tentacles. Translucent
            mollusks cling to the walls, beads of light refracting through their
            nearly invisible shells.
          </p>

          <p>
            The deeper they travel, the more the tunnel seems to become an alien
            ecosystem rather than simply a passage through the Earth. Every
            surface seems to contain something alive, luminous, or impossible.
          </p>

          <p>
            Then, once again, the scientists hear the ghostly narration of what
            seems to be a previous team of explorers.
          </p>

          <p>
            The recording warns them about the dangers ahead in{" "}
            <strong>Sector 05: Caustic Pools</strong>.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section2Data = [
    {
      title: "A CALL TO THE OBSERVATORY",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            Burns decides that the warning is serious enough to justify
            contacting Mission Control.
          </p>

          <p>
            He calls the Observatory far above and successfully connects with an
            operative. Burns asks for specifics about the dangers of Sector 05
            and how they might protect themselves.
          </p>

          <p>
            The operative begins searching through the available information. At
            one point, while the scientists are placed on hold, they hear
            another voice in the background:&nbsp;
            <font color="red">
              <strong>"Did the other group make it that far?"</strong>
            </font>
          </p>

          <p>
            The question is strange enough that both scientists take notice.
            When the operative returns, however, there is no mention of another
            expedition; the operative only reports fragmented drone data. The
            scientists receive an overview of roughly half of the encounter
            chart for the sector and gain{" "}
            <strong>advantage on their next skill check</strong>.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section3Data = [
    {
      title: "SECTOR 05: CAUSTIC POOLS",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            Sector 05 is a dangerous minefield of toxic, greenish pools filled
            with caustic liquids.
          </p>
          <p>
            <img src={sector05} alt="Caustic Pools" className="imageWrapper" />
          </p>
          <p>
            The green is laced with rust brown, fuligin black, and countless
            other colors produced by minerals and foreign material polluting the
            steamy run-offs of Earth's inner crust. Hundreds of kilometers
            above, slices of civilization are being crushed, melted, and forced
            downward into the deep Earth, adding the slag of human civilization
            to the already bizarre chemistry of the Fracture.
          </p>

          <p>
            Steam rises from the pools. Water drips from sweating stalactites.
            The air itself feels hostile.
          </p>

          <p>
            And the way ahead is filled with creatures; strange, eel-like
            organisms swimming through the air as if it were water.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section4Data = [
    {
      title: "THE SCHOOL IN THE AIR",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            The creatures resemble multi-colored moray eels, with pale patches
            of skin around their throats. They drift and twist through the
            vaporous atmosphere above the caustic pools, scattered throughout
            the entire chamber like a school suspended in an invisible ocean.
            Burns and Moshe are wary. They do not know whether the creatures
            might expel poisonous gas, protective fluids, or some other
            defensive substance if frightened. Burns decides that the best way
            forward may be to manipulate the air itself.
          </p>

          <p>
            Drawing on his understanding of currents and gravity, he
            successfully rigs his
            <strong> BeepBoBop</strong> with tonal routines designed to
            influence air currents through sound.
          </p>

          <p>
            The BeepBoBop produces carefully controlled sound waves that gently
            guide the creatures away from the scientists' path. The school parts
            around them, allowing Burns and Moshe to proceed without provoking
            the creatures.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section5Data = [
    {
      title: "CLUE 31: THE GRAVITY OF DARKNESS",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            Along the path cleared by the BeepBoBop, the scientists notice
            something moving in the clear air: an undulating shadow energy
            flickers in an ever-unique pattern. Darkness seems to dance in place
            without casting a shadow of its own. The scientists stop to study
            it.
          </p>
          <p>
            <img
              src={clue31}
              alt="Oscillating Shadows"
              className="imageWrapper"
            />
          </p>
          <p>
            One of the BeepBoBops begins drifting toward the oscillating
            darkness. The gravitational pull is not overwhelming, but it is
            unmistakable. The other BeepBoBop reacts quickly, grabbing its
            sibling with a hooked tether line and pulling it away. Moshe
            examines the phenomenon and realizes what he is seeing is a weak,
            miniature <strong>black hole</strong>.
          </p>

          <p>
            The scientists avoid the strange phenomenon, ruminating on a
            possible connection to the <strong>star in a jar</strong> they found
            earlier.
          </p>

          <p>
            Celestial phenomena. Gravity. Stars. Black holes. Whatever is
            happening deep beneath the Earth, these themes appear to be
            recurring.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section6Data = [
    {
      title: "SECTOR 06: GRAVITY INVERSION",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            With a stumbling <strong>TRAVEL</strong> roll, the scientists
            eventually make it to <strong>Sector 06: Gravity Inversion</strong>.
            The massive underground caverns are filled with enormous "islands"
            of rock floating in the air. The definition of up and down is
            visually unclear.
          </p>
          <p>
            <img
              src={sector06}
              alt="Gravity Inversion"
              className="imageWrapper"
            />
          </p>
          <p>
            As they cautiously explore, the gravity inversion begins shifting
            randomly. One moment they are walking along the walls. The next,
            they are falling toward the ceiling. Then they tumble toward what
            used to be the floor.
          </p>

          <p>
            Burns uses his BeepBoBop and climbing gear to tether himself to two
            different surfaces, ensuring that he has at least two stable points
            of grounding at all times. He uses his tethers to navigate the
            dangerous, shifting waves of gravitational changes.
          </p>

          <p>
            Moshe takes a different approach. He runs, jumps, and uses
            parkour-like movements to navigate the shifting surfaces, repeatedly
            adjusting his body to compensate for the changing direction of
            gravitational impact.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section7Data = [
    {
      title: "THE FINAL GRAVITY SHIFT",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            Then the gravity changes one final time; an explosive violent shift.
            Moshe is badly hurt. Burns is injured as well. Then, as suddenly as
            it began, the shifting planes of gravitational force settle down.
            Moshe has accumulated enough <strong>STRESS</strong> damage that his
            anomaly influence reaches <strong>BEYOND THE HORIZON</strong>.
          </p>
          <p>
            <img
              src={mosheBlackEyes}
              alt="Beyond the Horizon"
              className="imageWrapper"
            />
          </p>
          <p>
            The anomaly courses through Moshe. Chittering, susserating
            psychobabble fills his mind. Alien voices and impossible sounds
            drift through his consciousness like an audio cloud. Moshe
            understands more about the anomaly than he did before. The increased
            understanding brings with it new powers and insights.
          </p>

          <p>But there is a cost.</p>

          <p>
            He is becoming less grounded in conventional reality and is now at
            greater risk from the influence of the anomaly.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section8Data = [
    {
      title: "THE CRYSTALLINE SPIRE",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            Burns and Moshe establish their inflatable habitat and settle in to
            rest and <strong>STUDY</strong> the strange gravitational phenomenon
            of the sector. As they study and recover, a crystalline spire breaks
            through the floor of the habitat.
          </p>
          <p>
            <img
              src={clue44}
              alt="Crystalline Spire"
              className="imageWrapper"
            />
          </p>
          <p>
            The spire grows, as they watch; twisting and curling around it's own
            crystal latticework. Minute by minute, the crystal pushes upward
            through the habitat, growing with a speed that makes it impossible
            to mistake the event for a normal geological process.
          </p>

          <p>
            Moshe attempts to understand what is happening. Suddenly, his mind
            is filled with a cacaphony of chaos, a whirlpool of conflicting
            thoughts and impossible sensations. His eyes darken; the pupils
            disappear into complete darkness. The sclera become black as well.
            His eyes are now pitch dark; orbs of void as strange as the world
            they look out upon.
          </p>

          <p>
            The transformation becomes a visible symbol of his increasingly
            unmoored consciousness and his dangerous proximity to the anomaly's
            influence.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section9Data = [
    {
      title: "SECTOR 07: ALPHA PARTICLE GROVE",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            The scientists eventually travel onward into{" "}
            <strong>Sector 07: Alpha Particle Grove</strong>. This sector
            contains the bioluminescence, crystalline structures, and unearthly
            fauna found throughout the previous levels, but there is something
            new: mysterious particles float and drift through the atmosphere
            like neon patterns or paint strokes. They are countless variations
            of alpha particles decorating the air.
          </p>
          <p>
            <img
              src={sector07}
              alt="Alpha Particle Grove"
              className="imageWrapper"
            />
          </p>
          <p>
            The scientists realize that they could study this sector for months
            and barely scratch the surface of what is happening here. The air is
            filled with colors and shapes produced by particles that seem to
            defy the physics they know.
          </p>

          <p>
            Thanks to a few warning beeps from their BeepBoBop companions, the
            scientists narrowly avoid stepping on something strange.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section10Data = [
    {
      title: "THE CRUCIFORM BLEEDER",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            <img
              style={{
                maxWidth: "400px",
                height: "auto",
                float: "left",
                paddingRight: "10px",
              }}
              src={cruciformBleeder}
              alt="Cruciform Bleeder"
              className="imageWrapper"
            />
          </p>
          <p>
            On the ground lies what initially appears to be an inert,
            cross-shaped piece of wood. Closer inspection reveals that it is
            alive.
          </p>
          <p>
            The cruciform creature has hooked, crab-like legs that anchor it in
            place. Along the grooves of its seemingly bark-like skin, a thick
            red liquid oozes. The liquid is blood—or something close enough to
            blood for the scientists to call it that.
          </p>

          <p>
            DSPRT readings indicate that the substance generates significant
            warmth and is <strong>highly flammable</strong>. Once ignited, it
            would be extremely difficult to extinguish. Burns carefully collects
            a vial of the creature's explosive sanguinary excretion. You never
            know when a vial of flammable alien blood might come in handy.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section11Data = [
    {
      title: "THE ENERGY BEINGS",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            <img
              style={{
                maxWidth: "400px",
                height: "auto",
                float: "left",
                paddingRight: "10px",
              }}
              src={energyBeings}
              alt="Energy Beings"
              className="imageWrapper"
            />
          </p>
          <p>
            The scientists continue through the Alpha Particle Grove. Some time
            later, Moshe receives a series of odd signals from his BeepBoBop. He
            stops and looks back. A translucent lattice of energy particles in
            the shape of a humanoid is kneeling beside the BeepBoBop. One
            glowing hand touches the machine, its fingers represented by a
            constellation of luminous energy points.
          </p>
          <p>
            Another energy being emerges from the Alpha Grove near Burns. The
            beings are fascinated by the scientists'{" "}
            <strong>DSPRT exosuits</strong> and their BeepBoBops. With the help
            of the exosuit AI, the scientists can roughly understand the
            creatures. Their communication consists of a telegraphic series of
            sounds resembling Morse code, interrupted by random encryption-like
            spikes and valleys in the signal.
          </p>

          <p>
            Moshe's anomaly influence allows him to understand the code. Working
            through the exosuit systems, he patches both suits into the
            communication pattern so that Burns can understand as well. The
            beings are aware of the scientists and speak in a manner that
            includes them in a distant, egalitarian babble. Their speech seems
            intended for everyone to hear.
          </p>

          <p>
            Then the scientists understand what the beings are discussing. The
            exosuits would make excellent <strong>housing</strong>. The beings
            begin examining the scientists' equipment with increasing interest.
            Their curiosity begins to feel like a threat.Burns has his shotgun
            ready.
          </p>

          <p>
            Moshe decides to try communication before violence. His anomaly
            influence gives him enough understanding of their strange
            communication that he can imitate their Morse-like clicking. His
            voice rises into an approximation of their signal language. Moshe
            warns the creatures that they will be destroyed if they attempt to
            take the scientists or their equipment. The beings respond with a
            sound like <strong>white noise</strong>, their lights flicker, then
            they disappear.
          </p>

          <p>
            It is impossible to determine whether they scattered atomically,
            fled, or simply became camouflaged within the strange energy of the
            Alpha Particle Grove. Whatever happened, they are gone. The
            immediate danger has passed.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section12Data = [
    {
      title: "THE CRASHED SPHERE",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            <img
              style={{
                maxWidth: "400px",
                height: "auto",
                float: "left",
                paddingRight: "10px",
              }}
              src={visitorsOutOfTime}
              alt="Strangers"
              className="imageWrapper"
            />
          </p>
          <p>
            An hour later, the scientists enter a grove-like area enclosed by
            stalagmite columns. A stunning tableau awaits them. Near a metallic
            sphere with a circular opening stand two humanoids.
          </p>

          <p>
            One of the humanoids is a beautiful blonde woman wearing a long
            pearl-colored dress and a glowing purple necklace. Her right leg
            bears a long bloody slash. She is stumbling aimlessly, clearly in
            shock.
          </p>

          <p>
            On the ground nearby is something that cannot quite be called a man.
            It is the size and shape of a human, but it has glowing reddish eyes
            and greenish skin. It wears a tunic made of fur and clutches a leg
            covered in multiple lacerations oozing a dark liquid.
          </p>

          <p>
            Burns steps between the creature and the woman. He sees that the
            woman's left arm hangs like an empty sleeve of flesh. The bones and
            muscles appear to have been crushed, and blood trickles along the
            shattered limb before dripping from her fingertips onto the cavern
            floor. Her blood is the same red as human blood.
          </p>

          <p>
            Burns speaks of friendship and assistance, although he has no idea
            whether either of them understands English. The woman barely notices
            him. She sways on her feet, seemingly disconnected from everything
            around her. Moshe has assembled his gatling laser; calm but
            prepared.
          </p>

          <p>
            The creature speaks to Burns as it struggles to stand. Its voice
            sounds like rocks tumbling inside a machine, being polished against
            one another. Neither scientist can decode it. Even Moshe, despite
            his anomaly attunement, cannot understand what the creature is
            saying.
          </p>

          <p>
            Burns unfastens his medical kit from the metal clasps of his
            exosuit. Suddenly, the creature gets to its feet and runs into the
            metallic sphere. Moshe grabs his gatling laser and follows.
          </p>

          <p>
            Burns encourages the injured woman to sit on the ground so she will
            not fall. She does so. Her eyes remain vacant, but she now seems
            capable of registering his presence.
          </p>

          <p>
            Moshe approaches the sphere. Inside he can see the weak glow of
            instrument panels and electrical strobing. It must be some kind of
            craft. It looks as though it crashed into the ground. A spherical
            machine has crashed into the floor of a cave hundreds of kilometers
            beneath the Earth. How is that even possible?
          </p>

          <p>
            Moshe's thoughts are interrupted by the creature emerging from the
            sphere.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section13Data = [
    {
      title: "THE OVAL BLADE",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            The creature emerges from the sphere shouting in its rough, garbling
            tongue. Both hands grip a strange hilt. Above its head is an oval
            metal band humming and glowing with energy. It charges Moshe.
          </p>

          <p>
            Moshe reflexively fires his gatling laser. The laser energy is
            pulled toward the oval blade and glances away, deflected by some
            kind of energy field surrounding the weapon.
          </p>

          <p>
            Burns gasps and jumps to his feet, fumbling for his shotgun. Moshe
            keeps firing. The creature continues closing the distance.
          </p>

          <p>
            The laser bursts begin finding their target as the creature
            continues lumbering forward, carried by momentum and dying
            intention. The oval blade rises, itsmomentum appears unstoppable.
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  const section14Data = [
    {
      title: "THE LAST SHOT",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",

      text: (
        <div className="substratumProtocolBodyText">
          <p>
            An impossibly loud roar fills the cavern. The barrels of Burns
            shotgun are smoking.
          </p>
          <p>
            <img src={firefight} alt="Firefight" className="imageWrapper" />
          </p>
          <p>
            The blast slams the creature and it flies backward, dead. The oval
            weapon misses Moshe by mere inches and goes dark. For several
            seconds the two scientists simply stand there, panting, gathering
            their breath as the adrenaline spike courses through them.
          </p>

          <p>
            The creature lies dead on the cavern floor; its eyes no longer
            glowing and red, but dark and dull.
          </p>

          <p>
            Burns looks back toward the injured woman. She is lying prone on the
            ground, her chest heaving in desperate, shallow ripples.
          </p>

          <p>
            The scientists have survived the encounter. But their mysterious
            patient may not survive much longer.
            <strong>We will pick up here next session.</strong>
          </p>

          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundColor = "#c47768";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "IM Fell Great Primer",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <a name="pageTop" href="#pageTop">
                  <img
                    src={logo}
                    style={{
                      maxWidth: "400px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                    }}
                    alt="Substratum Protocol campaign"
                  />
                </a>
              </main>

              <h1 className="cover-heading">THE GRAVITY OF DARKNESS</h1>

              <h4>Substratum Protocol Session 03</h4>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card style={cardStyle}>
            <Card.Body>
              <Card.Title
                id="cardTitle-substratum-protocol"
                className="cardTitle-substratum-protocol"
              >
                <span
                  style={{
                    color: "black",
                    textAlign: "center",
                  }}
                >
                  Burns and Moshe descend from the Super-Heated Lake through the
                  Caustic Pools and Gravity Inversion, encounter a miniature
                  black hole, discover the Alpha Particle Grove, meet strange
                  energy beings, and survive a violent encounter with an alien
                  creature and its mysterious energy weapon.
                </span>
                <br />
                <small>
                  <span className="emoji" role="img" aria-label="lab coat">
                    🥼
                  </span>
                  <a href="./substratum-protocol-scientist-profile-moshe-mazel">
                    Dr. Moshe Mazel
                  </a>
                  <span className="emoji" role="img" aria-label="lab coat">
                    🥼
                  </span>
                  <a href="./substratum-protocol-scientist-profile-burnstein-grok">
                    Dr. Burnstein Grok
                  </a>
                  <br />
                  <span className="emoji" role="img" aria-label="earth">
                    🌎
                  </span>
                  <a href="./substratum-protocol-session-02">
                    Session 02: The Star in the Jar
                  </a>
                  <span className="emoji" role="img" aria-label="black hole">
                    🌎
                  </span>
                  Session 03: The Gravity of Darkness
                </small>
              </Card.Title>

              <div>
                <ContentContainer data={section1Data} />
              </div>

              <div>
                <ContentContainer data={section2Data} />
              </div>

              <div>
                <ContentContainer data={section3Data} />
              </div>

              <div>
                <ContentContainer data={section4Data} />
              </div>

              <div>
                <ContentContainer data={section5Data} />
              </div>

              <div>
                <ContentContainer data={section6Data} />
              </div>

              <div>
                <ContentContainer data={section7Data} />
              </div>

              <div>
                <ContentContainer data={section8Data} />
              </div>

              <div>
                <ContentContainer data={section9Data} />
              </div>

              <div>
                <ContentContainer data={section10Data} />
              </div>

              <div>
                <ContentContainer data={section11Data} />
              </div>

              <div>
                <ContentContainer data={section12Data} />
              </div>

              <div>
                <ContentContainer data={section13Data} />
              </div>

              <div>
                <ContentContainer data={section14Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SPSession03;
